import {
  XMarkIcon,
  PencilIcon,
  StarIcon,
} from '@heroicons/react/24/outline';
import { StarIcon as StarIconSolid } from '@heroicons/react/24/solid';
import React from 'react';

import LoadingSpinner from '../../../components/LoadingSpinner';
import { Chat } from '../types';

interface ChatTabActionsProps {
  chat: Chat;
  isStarring: boolean;
  onToggleStar: (chat: Chat) => void;
  onStartRename: (chat: Chat) => void;
  onCloseTab?: (chat: Chat) => void;
  isClosing?: boolean;
  /** Additional class for the star/rename/close hover container */
  hoverClassName?: string;
}

const ChatTabActions: React.FC<ChatTabActionsProps> = ({
  chat,
  isStarring,
  onToggleStar,
  onStartRename,
  onCloseTab,
  isClosing = false,
  hoverClassName = 'hover:bg-gray-300 hover:bg-opacity-50',
}) => {
  return (
    <>
      {/* Star Button */}
      <button
        onClick={e => {
          e.stopPropagation();
          onToggleStar(chat);
        }}
        disabled={isStarring}
        className={`p-1 rounded ${hoverClassName} transition-colors duration-200 disabled:opacity-50 disabled:cursor-not-allowed flex-shrink-0`}
        aria-label={chat.starred ? `Unstar ${chat.title}` : `Star ${chat.title}`}
        title={chat.starred ? 'Unstar chat' : 'Star chat'}
      >
        {isStarring ? (
          <LoadingSpinner size='xs' color='border-gray-400' />
        ) : chat.starred ? (
          <StarIconSolid className='w-3 h-3 text-yellow-500' />
        ) : (
          <StarIcon className='w-3 h-3 text-gray-500' />
        )}
      </button>

      {/* Rename Button */}
      <button
        onClick={e => {
          e.stopPropagation();
          onStartRename(chat);
        }}
        className={`p-1 rounded ${hoverClassName} transition-colors duration-200 flex-shrink-0`}
        aria-label={`Rename ${chat.title}`}
        title='Rename chat'
      >
        <PencilIcon className='w-3 h-3 text-gray-500' />
      </button>

      {/* Close Button */}
      {onCloseTab && (
        <button
          onClick={e => {
            e.stopPropagation();
            onCloseTab(chat);
          }}
          disabled={isClosing}
          className='p-1 rounded hover:bg-red-100 hover:text-red-600 transition-colors duration-200 flex-shrink-0 disabled:opacity-50 disabled:cursor-not-allowed'
          aria-label={`Close ${chat.title}`}
          title='Close tab'
        >
          {isClosing ? (
            <LoadingSpinner size='xs' color='border-gray-400' />
          ) : (
            <XMarkIcon className='w-3 h-3 text-gray-500 hover:text-red-600' />
          )}
        </button>
      )}
    </>
  );
};

export default ChatTabActions;
